import {
    Box,
    Button,
    List,
    ListItem,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import React from "react";
// import styles from "../../styles/pages/superadmin/message-details.module.scss";
import styles from "../../styles/pages/mymessage.module.scss";
import PrevIcon from "../../ui/Icons/PrevIcon";
// import Image from "next/image";
import assest from "../../json/assest";
// import { useRouter } from "next/router";
import { useNavigate } from "react-router";

const MessagePageLeftHeading = (props) => {
    // const { scroll, scroll2 } = props;
    const router = useNavigate();
    const goBackToMessages = () => {
        // router.replace("/message");
        router(props?.back_support ? "/message" : "/support");
    };
    return (
        <Box
            className={`${styles.msgdetails}`}
            // ${scroll || scroll2 > 60 ? styles.scroll_header : ""}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
                className={styles.detailsTopHeading}
            >
                <Typography variant="h3" className={styles.headingStyled}>
                    {props?.headingText}
                </Typography>
                <Button startIcon={<PrevIcon />} onClick={goBackToMessages}>
                    Back
                </Button>
            </Stack>
        </Box>
    );
};

export default MessagePageLeftHeading;
